// extracted by mini-css-extract-plugin
export default {"DownloadButton":"Footer_DownloadButton__eGqwE"};